const STORAGE_KEY_PREFIX = 'partnerRecentClients';

export const RECENT_CLIENTS_LIMIT = 5;

function storageKey(userId: string): string {
    return `${STORAGE_KEY_PREFIX}:${userId}`;
}

export function readRecentClientIds(userId: string): string[] {
    try {
        const raw = localStorage.getItem(storageKey(userId));
        const parsed: unknown = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((id): id is string => typeof id === 'string').slice(0, RECENT_CLIENTS_LIMIT);
    } catch {
        return [];
    }
}

export function withRecentClientId(recentClientIds: string[], clientId: string): string[] {
    return [clientId, ...recentClientIds.filter((id) => id !== clientId)].slice(0, RECENT_CLIENTS_LIMIT);
}

export function writeRecentClientIds(userId: string, recentClientIds: string[]): void {
    try {
        localStorage.setItem(storageKey(userId), JSON.stringify(recentClientIds));
    } catch (error) {
        console.error('Failed to save recent clients to localStorage:', error);
    }
}
